<script>
  import { onMount } from "svelte"
  import { fade, fly } from "svelte/transition"

  import Router from "./components/Router.svelte"
  import Route from "./components/Route.svelte"
  import Nav from "./components/Nav.svelte"
  import Footer from "./components/Footer.svelte"
  import Home from "./components/Home.svelte"
  import About from "./components/About.svelte"
  import Blog from "./components/Blog.svelte"
  import Account from "./components/Account.svelte"
  import Play from "./components/Play.svelte"
  import Books from "./components/Books.svelte"
  import Qi from "./components/Qi.svelte"
  import Records from "./components/Records.svelte"
  import XiYiAdmin from "./components/XiYiAdmin.svelte"
  import Demo from "./components/Demo.svelte"
  // import Payment from "./utils/Payment.svelte"
  import NotFound from "./components/NotFound.svelte"
  import PrivatePage from "./components/PrivatePage.svelte"
  import CancelOrder from "./components/CancelOrder.svelte"
  import SuccessOrder from "./components/SuccessOrder.svelte"
  import TextCipher from "./utils/TextCipher.svelte"

  let onLoad = false
  onMount(() => {
    setTimeout(() => (onLoad = true), 500)
  })
</script>

<!-- <div class="load" in:fly={{ y: 200, duration: 200 }} out:fade> -->
<!-- Nav -->
<Nav />
<!-- Main -->
{#if onLoad}
  <div class="load" transition:fade>
    <main>
      <div class="container">
        <div class="section">
          <!-- <Router hashbang={true}> -->
          <Router>
            <Route path="/"><Home /></Route>
            <Route path="/blog"><Blog /></Route>
            <Route path="/about"><About /></Route>
            <Route path="/account"><Account /></Route>
            <Route path="/play"><Play /></Route>
            <Route path="/books"><Books /></Route>
            <Route path="/qi"><Qi /></Route>
            <Route path="/records"><Records /></Route>
            <Route path="/xiyiadmin"><XiYiAdmin /></Route>
            <Route path="/demo"><Demo /></Route>
            <!-- <Route path="/payment"><Payment /></Route> -->
            <Route path="/404"><NotFound /></Route>
            <Route path="/private"><PrivatePage /></Route>
            <Route path="/cancel"><CancelOrder /></Route>
            <Route path="/success"><SuccessOrder /></Route>
            <Route path="/textcipher"><TextCipher /></Route>
          </Router>
        </div>
      </div>
    </main>
    <!-- Footer -->
    <Footer />
  </div>
{:else}
  <div class="loading white-text indigo darken-1">
    <h1 class="center">【XiYi習易網】 載入中···</h1>
  </div>
{/if}

<style>
  .loading {
    width: 100%;
    height: 1000px;
    padding-top: 300px;
    font-size: 1000;
    font-weight: 800;
  }
</style>
